import Button from "./components/Button.vue";
import Scrollbar from "./components/Scrollbar.vue";
import Appbar from "./components/Appbar.vue";
import AppbarTitle from "./components/AppbarTitle.vue";
import IconButton from "./components/IconButton.vue";
import Icon from "./components/Icon.vue";
import Navigation from "./components/Navigation.vue";
import List from "./components/List.vue";
import ListItem from "./components/ListItem.vue";
import Textfield from "./components/Textfield.vue";
import DropdownField from "./components/DropdownField.vue";
import Checkbox from "./components/Checkbox.vue";
import Radio from "./components/Radio.vue";
import Tree from "./components/Tree.vue";
import Multifield from "./components/Multifield.vue";
import Card from "./components/Card.vue";
import Overlay from "./components/Overlay.vue";
import DataTable from "./components/DataTable.vue";
import Tab from "./components/Tab.vue";
import TabItem from "./components/TabItem.vue";
import Menu from "./components/Menu.vue";
import Avatar from "./components/Avatar.vue";
import { prefix } from "./prefix";

export default Vue => {
  Vue.component(`${prefix}-button`, Button);
  Vue.component(`${prefix}-button`, Button);
  Vue.component(`${prefix}-scrollbar`, Scrollbar);
  Vue.component(`${prefix}-appbar`, Appbar);
  Vue.component(`${prefix}-appbar-title`, AppbarTitle);
  Vue.component(`${prefix}-icon-button`, IconButton);
  Vue.component(`${prefix}-icon`, Icon);
  Vue.component(`${prefix}-navigation`, Navigation);
  Vue.component(`${prefix}-list`, List);
  Vue.component(`${prefix}-list-item`, ListItem);
  Vue.component(`${prefix}-textfield`, Textfield);
  Vue.component(`${prefix}-dropdown-field`, DropdownField);
  Vue.component(`${prefix}-checkbox`, Checkbox);
  Vue.component(`${prefix}-radio`, Radio);
  Vue.component(`${prefix}-tree`, Tree);
  Vue.component(`${prefix}-multifield`, Multifield);
  Vue.component(`${prefix}-card`, Card);
  Vue.component(`${prefix}-overlay`, Overlay);
  Vue.component(`${prefix}-datatable`, DataTable);
  Vue.component(`${prefix}-tab`, Tab);
  Vue.component(`${prefix}-tab-item`, TabItem);
  Vue.component(`${prefix}-menu`, Menu);
  Vue.component(`${prefix}-avatar`, Avatar);
};
